<template>
  <div id="list">
    <label v-for="option in options" :key="option.id" class="container">
      {{ option.name }}
      <input
        type="radio"
        :checked="option.checked"
        name="radio"
        :value="option.id"
        @click="clicked(option)"
      />
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'RadioSet',
  props: ['modelValue', 'options'],
  emits: ['update:modelValue'],
  methods: {
    clicked(option) {
      this.$emit('update:modelValue', option)
    }
  }
}
</script>

<style scoped>
/* The container */
.container {
  text-align: left;
  display: block;
  position: relative;
  padding-left: 10%;
  margin-bottom: 1.2em;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: -0.4em;
  left: 0;
  height: 2em;
  width: 2em;
  background-color: #eee;
  border-radius: 50%;
  box-sizing: border-box;
  border: solid 2px #cacaca;
}

/* When the radio button is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #e6e6e6;
  border: solid 2px #cacaca;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: '';
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.container .checkmark:after {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1em;
  height: 1em;
  border-radius: 50%;
  background: #505050;
}
</style>
